import { render, staticRenderFns } from "./TotalNilaiTransaksi.vue?vue&type=template&id=6bacf002&"
import script from "./TotalNilaiTransaksi.vue?vue&type=script&lang=js&"
export * from "./TotalNilaiTransaksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports